import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { ClockIcon, FlameIcon } from './icons/Icons';
export function HookSection() {
  return <section className="relative w-full overflow-hidden bg-[#202923] py-16 text-white sm:py-24" data-id="element-200" data-mp="m7a1mtrdp6kt">
      <div className="absolute inset-x-0 top-0 h-px bg-[#9fbd91]/30" aria-hidden="true" data-id="element-201" data-mp="m9319p3kqqjb" />
      <div className="mx-auto max-w-3xl px-5" data-id="element-202" data-mp="haja9aa4iok3">
        <Reveal data-id="element-203" data-mp="3pn74sir4he9n">
          <div className="flex items-center justify-center gap-3 text-[#ffc18d]" data-id="element-204" data-mp="3porzc8dfsx7i">
            <motion.span whileInView={{
            scale: [1, 1.12, 1]
          }} viewport={{
            amount: 0.5
          }} transition={{
            duration: 1.8,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="flex h-12 w-12 items-center justify-center rounded-full bg-[#e0611f]/15" data-id="element-205" data-mp="3kpxgj6fgz8ne">
              <ClockIcon className="h-7 w-7" strokeWidth={2} data-id="element-206" data-mp="1dx4o8inuqi5s" />
            </motion.span>
            <p className="font-display text-sm font-extrabold uppercase tracking-[0.16em]" data-id="element-207" data-mp="19vszefcsy0yn">La historia que conoces demasiado bien</p>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-208" data-mp="3lzsslzh8ofe1">
          <h2 className="mt-7 text-center font-display text-3xl font-black leading-tight sm:text-5xl" data-id="element-209" data-mp="3lyzufmwciy7i">
            Eran las 3 de la mañana. <span className="text-[#ff9a61]" data-id="element-210" data-mp="3q2fnk997igfg">Otra vez.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.14} data-id="element-211" data-mp="3v07ht9xbqemt">
          <div className="mt-8 space-y-5 text-lg leading-relaxed text-white/78" data-id="element-212" data-mp="3uyd2cb4tneq4">
            <p data-id="element-213" data-mp="2y8dlzuifjbwz">Sentada en el borde de tu cama, con esa sensación de fuego subiendo por tu pecho, preguntándote si esta vez sí era un infarto.</p>
            <p data-id="element-214" data-mp="37amuyfy1ux89">Tomas otro antiácido. El cuarto de la semana. Sabes que en una hora el ardor volverá.</p>
            <p className="font-display text-2xl font-extrabold text-white" data-id="element-215" data-mp="3c24vx402oxt8">Y lo peor no es el dolor físico.</p>
            <p data-id="element-216" data-mp="2elfzjptw6nr8">Es ver a tu familia disfrutar la cena mientras tú calculas en silencio qué te va a caer mal. Es cancelar salidas. Es sentir que tu propio cuerpo te traicionó.</p>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-217" data-mp="3mv6nxgb2yemm">
          <div className="mt-9 flex items-start gap-4 rounded-2xl border border-[#9fbd91]/25 bg-white/[0.06] p-5 sm:p-6" data-id="element-218" data-mp="3mudcw35392yo">
            <FlameIcon className="mt-1 h-7 w-7 shrink-0 text-[#ff9a61]" strokeWidth={2} data-id="element-219" data-mp="3vos0qu3oplte" />
            <p className="font-display text-lg font-bold leading-relaxed text-white sm:text-xl" data-id="element-220" data-mp="3rn6jkwk4alde">
              Si esto te describe, sigue leyendo. Porque lo que estás a punto de descubrir lo cambia todo.
            </p>
          </div>
        </Reveal>
      </div>
    </section>;
}